var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2073(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 209,
    viewBox: "0 0 324 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4026_51738)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7109,
    y: 18.9648,
    width: 294.549,
    height: 175.539,
    rx: 26.7771,
    fill: "url(#paint0_linear_4026_51738)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 35.5371,
    y: 51.6914,
    width: 50.579,
    height: 38.6781,
    rx: 10.4133,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 256.449,
    cy: 71.0298,
    rx: 21.5705,
    ry: 20.8267,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.16,
    cy: 71.0298,
    rx: 21.5705,
    ry: 20.8267,
    fill: "#D5DDEA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9746 160.287C42.9746 157.822 44.8559 155.824 47.1765 155.824H89.1952C91.5158 155.824 93.3971 157.822 93.3971 160.287C93.3971 162.752 91.5158 164.75 89.1952 164.75H47.1765C44.8559 164.75 42.9746 162.752 42.9746 160.287Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.003 160.287C106.003 157.822 107.884 155.824 110.205 155.824H152.223C154.544 155.824 156.425 157.822 156.425 160.287C156.425 162.752 154.544 164.75 152.223 164.75H110.205C107.884 164.75 106.003 162.752 106.003 160.287Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.031 160.287C169.031 157.822 170.912 155.824 173.233 155.824H215.251C217.572 155.824 219.453 157.822 219.453 160.287C219.453 162.752 217.572 164.75 215.251 164.75H173.233C170.912 164.75 169.031 162.752 169.031 160.287Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.059 160.287C232.059 157.822 233.94 155.824 236.261 155.824H278.279C280.6 155.824 282.481 157.822 282.481 160.287C282.481 162.752 280.6 164.75 278.279 164.75H236.261C233.94 164.75 232.059 162.752 232.059 160.287Z",
    fill: "#1D1D1D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4026_51738",
    x: 0.661413,
    y: 0.915319,
    width: 322.867,
    height: 208.119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.95048,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4026_51738"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4026_51738"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.95048,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4026_51738"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4026_51738",
    result: "effect2_dropShadow_4026_51738"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4026_51738",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4026_51738",
    x1: 24.9686,
    y1: 192.426,
    x2: 20.1145,
    y2: 31.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2073);
export default __webpack_public_path__ + "static/media/Group 2073.176077e1626c66fad128c996e32a3087.svg";
export { ForwardRef as ReactComponent };